import _ from 'lodash';
import {
	ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS,
	BUDGET_SUB_TAB_CHANGED, END_TRANSACTION_EDIT_MODE,
	LOGOUT_BEGIN,
	SET_PLAYER,
	SET_SELECTED_MAIN_TAB, START_TRANSACTION_EDIT_MODE,
	SUMMARY_PAGE_TAB_CHANGE
} from "../actions/dashboard.js";
import { NET_SPENDING_TAB_CHANGED, SET_LOGIN_PAGE, TRANSACTIONS_VIEW_CHANGED, transactionsViews, URL_POPSTATE } from "../actions/url.js";
import LadderLocalStorage from "../../utilities/LadderLocalStorage.jsx";
import { SETTINGS_TAB_CHANGE } from "../actions/settings.js";
import { CHANGE_CALENDAR_VIEW_MODE } from "../actions/calendar.js";
import { calendarPageViews } from "./calendar.js";
import TransactionRenderKey from "../../utilities/TransactionRenderKey.jsx";
import findTransactionByRenderKey from "../../utilities/findTransactionByRenderKey.js";


const baseUrl = new URL(window.location.href);

class UrlPaths {
	constructor() {

	}

	setPaths(paths) {

	}
}

const urlPaths = new UrlPaths();

let isFirst = true;

function deriveUrlFromState(state, allState, changeHistory = true) {
	const { player } = allState.dashboard;
	const { url } = state;
	let newUrl = null;
	let replaceState = false;

	urlPaths.setPaths(
		{
			path: 'dashboard',
			isValid: !!player,
			defaultChild: 'budget',
			children: [
				{
					path: 'budget',
					children: [{
						path: 'summary',
					}]
				},
				{
					path: 'transactions',
				},
				{
					path: 'settings',
				},
				{
					path: 'calendar',
				}
			]
		},
		{
			path: 'log-in',
			isValid: !player,
		},
		{
			path: 'sign-up',
			isValid: !player,
		},
	);

	if(player) {
		const { selectedMainTab, activeBudgetSubTab, currentActiveSettingsTab, summaryPageSelectedTab, netSpendingTab, currentCalendarViewMode } = state;

		addToNewUrl('dashboard');
		const mainTab = selectedMainTab || 'budget';
		// console.log('we have', mainTab, activeBudgetSubTab);

		addToNewUrl(mainTab);
		if(mainTab === 'summary') {
			console.log('summary selected', summaryPageSelectedTab);
			if(summaryPageSelectedTab) {
				addToNewUrl(summaryPageSelectedTab);
			} else {
				addToNewUrl('pie');
			}

			if(summaryPageSelectedTab === 'net') {
				if(netSpendingTab) {
					addToNewUrl(netSpendingTab);
				} else {
					addToNewUrl('spending-by-month');
				}
			}
		}
		if(mainTab === 'budget') {
			let budgetSubTab = activeBudgetSubTab;
			// console.log('sub tab', budgetSubTab);
			if(budgetSubTab) {
				addToNewUrl(budgetSubTab);

			} else {
				if(allState.settings.separateBudgetTabsFeatureActive) {
					const lastSaved = LadderLocalStorage.getItem('activeBudgetSubTab', 'income');
					addToNewUrl(lastSaved);

				} else {
					addToNewUrl('budgets');
				}
			}
		}
		if(mainTab === 'transactions') {
			// A transaction being edited has the url to itself; closing it goes back to the tab.
			if(allState.dashboard.transactionBeingEdited) {
				const transaction = allState.dashboard.transactionBeingEdited;
				if(_.isString(transaction)) {
					addToNewUrl(transaction);
				} else {
					addToNewUrl(transaction.getRenderKey());
				}
			} else if(state.transactionsView === transactionsViews.DUPLICATES || state.transactionsView === transactionsViews.UNBUDGETED) {
				addToNewUrl(state.transactionsView);
			} else {
				replaceState = true;
			}
		}
		if(mainTab === 'settings') {
			if(currentActiveSettingsTab) {
				addToNewUrl(currentActiveSettingsTab);
			} else {
				addToNewUrl('accounts');
			}
		}
		if(mainTab === 'calendar') {
			let calendarViewPage = currentCalendarViewMode || calendarPageViews.GROCERY_CALENDAR.toLowerCase();
			addToNewUrl(calendarViewPage);
			if(currentCalendarViewMode === 'groceries') {
				if(allState.calendar.lastSelectedGroceryList) {
					addToNewUrl(allState.calendar.lastSelectedGroceryList);
				}
			}
		}
	} else {
		if(url[0] !== state.loginPage) {
			addToNewUrl(state.loginPage);
		}
	}

	let newState = state;
	if(newUrl) {
		newState = { ...state };
		newState.url = newUrl;
		if(changeHistory && !_.isEqual(newState.url, state.url)) {
			if(isFirst || !replaceState) {
				history.pushState({}, '', `${baseUrl.protocol}//${baseUrl.hostname}/${newUrl.join('/')}`);
			} else {
				history.replaceState({}, '', `${baseUrl.protocol}//${baseUrl.hostname}/${newUrl.join('/')}`);
			}
		}
	} else {
	}
	isFirst = false;
	return newState;

	function addToNewUrl(urlPart) {
		if(!newUrl) {
			newUrl = [];
		}
		newUrl.push(urlPart);
	}
}

/**
 * `transactionsLoaded` is for Back and Forward, which reach a url naming a transaction after the
 * transactions have loaded, so nothing else will turn the key into one. A key that names nothing
 * then closes the edit modal, and comes off the url, rather than leaving it loading forever.
 */
function deriveStateFromUrl(state, allState, transactionsLoaded = false) {
	const deriveUrl = new URL(window.location.href);

	const urlSplit = deriveUrl.pathname.split('/');
	urlSplit.shift();
	const splitOne = urlSplit[0] || 'dashboard';
	if(splitOne === 'dashboard') {
		const newState = {
			...state
		};
		let droppedTransactionKey = false;
		newState.selectedMainTab = urlSplit[1] || 'budget';
		const split2 = urlSplit[2];
		switch(newState.selectedMainTab) {
			case 'transactions': {
				const isTab = split2 === transactionsViews.DUPLICATES || split2 === transactionsViews.UNBUDGETED;
				newState.transactionsView = isTab ? split2 : transactionsViews.ALL;
				if(isTab) {
					allState.dashboard.transactionBeingEditedModalShouldBeOpen = false;
				} else if(split2 && transactionsLoaded) {
					const found = findTransactionByRenderKey(allState.dashboard.transactionFinder, split2);
					allState.dashboard.transactionBeingEdited = found;
					allState.dashboard.transactionBeingEditedModalShouldBeOpen = !!found;
					droppedTransactionKey = !found;
				} else if(split2) {
					allState.dashboard.transactionBeingEdited = split2;
				} else {
					allState.dashboard.transactionBeingEditedModalShouldBeOpen = false;

				}
				break;
			}
			case 'summary': {
				newState.summaryPageSelectedTab = urlSplit[2];
				if(urlSplit[2] === 'net') {
					newState.netSpendingTab = urlSplit[3];
				}
				break;
			}
			case 'budget': {
				newState.activeBudgetSubTab = split2 || LadderLocalStorage.getItem('activeBudgetSubTab', 'expenses');
				break;
			}
			case 'calendar': {
				newState.currentCalendarViewMode = split2;
				break;
			}
			case 'settings': {
				newState.currentActiveSettingsTab = split2;
				break;
			}
		}
		newState.url = deriveUrlFromState(newState, allState, false).url;
		if(droppedTransactionKey) {
			window.history.replaceState(window.history.state, '', `/${newState.url.join('/')}`);
		}
		return newState;
	}
	return state;
}

export default (state, action, fullState) => {
	const initialState = {
		url: [],
		loginPage: 'sign-up',
		selectedMainTab: null,
		activeBudgetSubTab: null, //LadderLocalStorage.getItem('activeBudgetSubTab', null),
		currentActiveSettingsTab: 'account',// LadderLocalStorage.getItem('currentActiveSettingsTab', null),
		summaryPageSelectedTab: 'general', // LadderLocalStorage.getItem('summaryPageSelectedTab', null),
		netSpendingTab: 'spending-by-month', // LadderLocalStorage.getItem('netSpendingTab', null),
		transactionsView: transactionsViews.ALL,
		currentCalendarViewMode: calendarPageViews.GROCERY_CALENDAR.toLowerCase(), // LadderLocalStorage.getItem('currentCalendarViewMode', calendarPageViews.GROCERY_CALENDAR),
	};
	if(state === undefined) {
		return {
			...initialState,
			...deriveStateFromUrl(initialState, fullState)
		};
	}
	switch(action.type) {
		case URL_POPSTATE: {
			console.log('we got popstate', action.payload);
			return {
				...state,
				...deriveStateFromUrl(state, fullState, true)
			};
		}
		case SETTINGS_TAB_CHANGE: {
			const setTo = action.payload;
			LadderLocalStorage.setItem('currentActiveSettingsTab', setTo);
			return updateState({
				currentActiveSettingsTab: setTo,
			});
		}
		case BUDGET_SUB_TAB_CHANGED:
			LadderLocalStorage.setItem('activeBudgetSubTab', action.payload);
			return updateState({
				activeBudgetSubTab: action.payload,
			});
		case SET_LOGIN_PAGE:
			return updateState({
				loginPage: action.payload,
			});
		case SET_SELECTED_MAIN_TAB:
			return updateState({
				selectedMainTab: action.payload
			});
		case SUMMARY_PAGE_TAB_CHANGE: {
			LadderLocalStorage.setItem('summaryPageSelectedTab', action.payload);
			return updateState({
				summaryPageSelectedTab: action.payload
			});
		}
		case NET_SPENDING_TAB_CHANGED: {
			LadderLocalStorage.setItem('netSpendingTab', action.payload);
			return updateState({
				netSpendingTab: action.payload
			});
		}
		case TRANSACTIONS_VIEW_CHANGED: {
			return updateState({
				transactionsView: action.payload,
			});
		}
		case CHANGE_CALENDAR_VIEW_MODE: {
			LadderLocalStorage.setItem('currentCalendarViewMode', action.payload);
			return updateState({
				currentCalendarViewMode: action.payload
			});
		}
		case END_TRANSACTION_EDIT_MODE:
		case ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS:
		case START_TRANSACTION_EDIT_MODE:
		case LOGOUT_BEGIN:
		case SET_PLAYER:
			return deriveUrlFromState(state, fullState);
		default:
			return state;
	}

	function updateState(stateToAdd) {
		const newState = {
			...state,
			...stateToAdd,
		};
		return {
			...newState,
			...deriveUrlFromState(newState, fullState),
		};
	}
};